// frontend/src/component/Home.jsx
import React, { useEffect, useState } from "react";
import HeroCarousel from "./HomeHeroCarousel";
import USPBar from "./HomeUSPBar";
import CategoryChips from "./HomeCategoryChips";
import HomePromoGrid from "./HomePromoGrid";
import HomeProductShelf from "./HomeProductShelf";
import BigFeatureBanner from "./HomeBigFeatureBanner";
import BlogTeasers from "./HomeBlogTeasers";
import slides from "./homeSlidesData";

import aquarium from "./Image/aquarium.png";
import shovel from "./Image/lopata.jpg"; // картинка лопаты

function useShelf(api) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
    let ignore = false;
    (async () => {
      try {
        setLoading(true);
        const r = await fetch(api);
        if (!r.ok) throw new Error(String(r.status));
        const data = await r.json();
        if (!ignore) setItems(Array.isArray(data) ? data : []);
      } catch (e) {
        if (!ignore) setError(e);
      } finally {
        if (!ignore) setLoading(false);
      }
    })();
    return () => {
      ignore = true;
    };
  }, [api]);
  return { items, loading, error };
}

export default function Home() {
  const best = useShelf(
    "/api/catalog/products/shelf/?shelf=bestsellers&limit=20"
  );
  const news = useShelf("/api/catalog/products/shelf/?shelf=new&limit=20");

  return (
    <div className="w-full min-h-screen flex flex-col bg-[#edeff1]">
      {/* 1) Видео баннер */}
      <HeroCarousel slides={slides} />

      {/* 2) Информация */}
      <USPBar />

      {/* 3) Категории */}
      <CategoryChips
        categories={[
          {
            id: 1,
            title: "Смартфоны",
            href: "https://mi64.eight-percent.com/price?q=%D0%A1%D0%BC%D0%B0%D1%80%D1%82%D1%84%D0%BE%D0%BD",
          },
          {
            id: 2,
            title: "Роботы-пылесосы",
            href: "https://mi64.eight-percent.com/price?q=%D0%A0%D0%BE%D0%B1%D0%BE%D1%82-%D0%BF%D1%8B%D0%BB%D0%B5%D1%81%D0%BE%D1%81",
          },
          {
            id: 3,
            title: "Наушники",
            href: "https://mi64.eight-percent.com/price?q=%D0%9D%D0%B0%D1%83%D1%88%D0%BD%D0%B8%D0%BA%D0%B8",
          },
          {
            id: 4,
            title: "Увлажнители",
            href: "https://mi64.eight-percent.com/price?q=%D0%A3%D0%B2%D0%BB%D0%B0%D0%B6%D0%BD%D0%B8%D1%82%D0%B5%D0%BB%D1%8C",
          },
        ]}
      />

      {/* 4) Акции и предложения */}
      <HomePromoGrid />

      {/* 5) Хиты продаж */}
      <div className="w-full mb-4">
        <div className="max-w-7xl mx-auto px-4 flex items-center justify-between">
          <h2 className="text-2xl font-bold">Хиты продаж</h2>
        </div>
      </div>
      <HomeProductShelf {...best} />

      {/* 6) Аквариум — большой баннер */}
      <BigFeatureBanner
        image={aquarium}
        title="Умный аквариум Xiaomi Mijia 10L"
        description={
          <p className="text-gray-600 text-sm mb-3">
            Оснащён системой автоматической подачи корма, 5-ступенчатой
            фильтрацией, настраиваемой RGB-подсветкой и управлением через
            приложение Mi Home. Сверхпрозрачное стекло UHA обеспечивает отличный
            обзор, а интеллектуальный насос позволяет сливать воду одним
            нажатием.
          </p>
        }
        href="https://mi64.eight-percent.com/price?q=%D0%B0%D0%BA%D0%B2%D0%B0%D1%80%D0%B8%D1%83%D0%BC"
        cta="Купить"
        imagePosition="50% 30%"
        priority={true}
      />

      {/* 7) Новые поступления */}
      <div className="w-full mb-4 mt-8">
        <div className="max-w-7xl mx-auto px-4 flex items-center justify-between">
          <h2 className="text-2xl font-bold">Новые поступления</h2>
        </div>
      </div>
      <HomeProductShelf {...news} />

      {/* 8) Рекламный баннер (пример, если понадобится)
      <BigFeatureBanner
        image={kitchen}
        title="Товары для кухни от Xiaomi"
        text="Готовьте с технологичностями — подборка техники с выгодой"
        href="https://mi64.eight-percent.com/price"
        cta="Посмотреть"
      /> */}

      <BlogTeasers posts={window.__BLOG__ ?? []} />

      {/* 9) Лопата — большой баннер (в самом конце) */}
      <BigFeatureBanner
        image={shovel}
        title="Лопата Xiaomi NexTool Shovel KT5524"
        description={
          <p className="text-gray-600 text-sm mb-3">
            С этой лопатой вы сможете с должным уважением закопать своих рыбок
            после завершения жизненного цикла — а ещё выкопать лунку под
            растение, расчистить снег у порога или взять её в поход. Прочная
            сталь, разборная рукоять, компактно помещается в багажнике.
          </p>
        }
        cta="Смотреть в каталоге"
        href="/price?q=%D0%BB%D0%BE%D0%BF%D0%B0%D1%82%D0%B0%20NexTool"
        imageFit="cover" // ← заполняем весь блок
        imagePosition="60% 50%" // ← сдвиг фокуса, чтобы лопата была в кадре
        className="mb-12" // отступ снизу, чтобы не слипалось с футером
      />
    </div>
  );
}
